module.exports = __webpack_public_path__ + "h5/img/lottery-demo.803bfec8.png";